import { render, staticRenderFns } from "./SlidingBayDamageSeverity.vue?vue&type=template&id=aa62eb52&scoped=true"
import script from "./SlidingBayDamageSeverity.vue?vue&type=script&lang=ts"
export * from "./SlidingBayDamageSeverity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa62eb52",
  null
  
)

export default component.exports